import type { PageContext } from 'vike/types';
import { asCopyLocale, pageCopy, salaryPageCopy } from './seo-copy';

export default (pageContext: PageContext) => {
  // +onBeforeRoute strips the locale prefix from urlPathname and records it on the context, so
  // read it from there; falling back to the original URL keeps this correct if that ever changes.
  const supportedLocales = ['en', 'fi', 'sv'];
  const ctxLocale = (pageContext as { locale?: string }).locale;
  const firstSegment = (pageContext.urlOriginal || pageContext.urlPathname || '/').split('?')[0].split('/').filter(Boolean)[0];
  const locale = ctxLocale && supportedLocales.includes(ctxLocale) ? ctxLocale : supportedLocales.includes(firstSegment) ? firstSegment : 'en';

  const slug = (pageContext.routeParams as { slug?: string } | undefined)?.slug;
  const copyLocale = asCopyLocale(locale);
  return `${salaryPageCopy(copyLocale, slug)?.title ?? pageCopy(copyLocale).title} | JobCrawls`;
};
